import { SxProps, Theme } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { Controller } from 'react-hook-form'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjs, { Dayjs } from 'dayjs'
import { Moment } from 'moment'
import DatePickerProvider from '../DatePicker/DatePickerProvider'
dayjs.extend(utc)
dayjs.extend(timezone)

type FormInputProps = {
    name: string
    control: any
    label: string
    setValue?: any
    sx?: SxProps<Theme>

    format?: string

    minDate?: Dayjs
    maxDate?: Dayjs

    disabled?: boolean
    shouldDisableDate?: (day: Dayjs | Moment) => boolean
}
const FormDatePickerDayjs = ({
    name,
    control,
    label,
    sx,
    minDate,
    maxDate,
    disabled,
    format,
    shouldDisableDate,
}: FormInputProps) => {
    return (
        <DatePickerProvider>
            <Controller
                name={name}
                control={control}
                render={(renderProps) => (
                    <DatePicker
                    sx={sx}
                    label={label}
                    format={format || 'dddd, MMMM DD, YYYY'}
                    value={
                        renderProps.field.value
                            ? dayjs
                                  .unix(renderProps.field.value)
                                  .tz('Australia/Melbourne')
                            : null
                    }
                    // value={moment.unix(renderProps.field.value).tz('Australia/Melbourne')}
                    onChange={(e) => renderProps.field.onChange(e?.unix())}
                    minDate={minDate}
                    maxDate={maxDate}
                    readOnly={disabled}
                    shouldDisableDate={shouldDisableDate}
                    />
                )}
            />
        </DatePickerProvider>
    )
}

export default FormDatePickerDayjs
